import React from 'react';
import { useBlockchainData } from '../hooks/useBlockchainData';
import { useWeb3 } from '../contexts/Web3Context';

const Analytics: React.FC = () => {
  const { provider } = useWeb3();
  const { puzoUsdtPool, totalLiquidity, totalPairs, volume24h } = useBlockchainData(provider);

  const formatBalance = (balance: string) => {
    return parseFloat(balance).toLocaleString('en-US', {
      maximumFractionDigits: 6
    });
  };

  const formatCurrency = (value: string) => {
    return parseFloat(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div>
      <div className="interface-panel mb-20">
        <div className="panel-header">
          <div className="panel-title">Market Overview</div>
        </div>
        <div className="panel-content">
          <div className="quantum-stats">
            <div className="quantum-stat">
              <div className="stat-label">Total Liquidity</div>
              <div className="stat-value">${formatCurrency(totalLiquidity)}</div>
            </div>
            <div className="quantum-stat">
              <div className="stat-label">24h Volume</div>
              <div className="stat-value">${formatCurrency(volume24h)}</div>
            </div>
            <div className="quantum-stat">
              <div className="stat-label">Active Pairs</div>
              <div className="stat-value">{totalPairs}</div>
            </div>
            {puzoUsdtPool && (
              <div className="quantum-stat">
                <div className="stat-label">PUZO Price</div>
                <div className="stat-value">
                  ${(parseFloat(puzoUsdtPool.reserve1) / parseFloat(puzoUsdtPool.reserve0)).toFixed(6)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {puzoUsdtPool && (
        <>
          <div className="interface-panel mb-20">
            <div className="panel-header">
              <div className="panel-title">PUZO/USDT Pool</div>
            </div>
            <div className="panel-content">
              <div className="quantum-stats">
                <div className="quantum-stat">
                  <div className="stat-label">PUZO Reserve</div>
                  <div className="stat-value">{formatBalance(puzoUsdtPool.reserve0)}</div>
                </div>
                <div className="quantum-stat">
                  <div className="stat-label">USDT Reserve</div>
                  <div className="stat-value">{formatBalance(puzoUsdtPool.reserve1)}</div>
                </div>
                <div className="quantum-stat">
                  <div className="stat-label">Total LP</div>
                  <div className="stat-value">{formatBalance(puzoUsdtPool.totalSupply)}</div>
                </div>
                <div className="quantum-stat">
                  <div className="stat-label">Pool Value</div>
                  <div className="stat-value">
                    ${(parseFloat(puzoUsdtPool.reserve1) * 2).toFixed(2)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="interface-panel">
            <div className="panel-header">
              <div className="panel-title">Pool Information</div>
            </div>
            <div className="panel-content">
              <div style={{marginBottom: '16px'}}>
                <div style={{fontSize: '0.7rem', color: '#888', marginBottom: '4px'}}>POOL ADDRESS</div>
                <div style={{fontSize: '0.8rem', wordBreak: 'break-all'}}>
                  {puzoUsdtPool.address}
                </div>
              </div>
              
              <div style={{display: 'grid', gap: '12px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem'}}>
                  <span style={{color: '#888'}}>Token Ratio:</span>
                  <span>1 PUZO = {(parseFloat(puzoUsdtPool.reserve1) / parseFloat(puzoUsdtPool.reserve0)).toFixed(6)} USDT</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem'}}>
                  <span style={{color: '#888'}}>Pool Share Value:</span>
                  <span>${(parseFloat(puzoUsdtPool.reserve1) * 2 / parseFloat(puzoUsdtPool.totalSupply)).toFixed(6)} per LP</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem'}}>
                  <span style={{color: '#888'}}>Mining Reward:</span>
                  <span>1 Range = 1 PUZO</span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {!puzoUsdtPool && (
        <div className="system-alert">
          <div style={{textAlign: 'center', color: '#888'}}>
            Loading pool data...
          </div>
        </div>
      )}
    </div>
  );
};

export default Analytics;
